<template>
  <div class="">
    <div class="flex items-center mb-2 space-x-4">
      <!-- Select Component -->
      <div class="flex flex-col space-x-2 items-left -mt-7">
        <label
          for="mobileSelect"
          class="ml-2 text-sm font-medium text-gray-700 "
          >Select Mobile to WhatsApp invoice
        </label>
        <select
          id="mobileSelect"
          v-model="selectedMobile"
          class="px-4 py-2 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option
            v-for="(item, index) in userMobiles"
            :value="item.value"
            :label="item.label + ' : '+ item.value"
            :key="index"
            >{{ item }}</option
          >
          <option value="">Enter Manually</option>
        </select>
      </div>

      <!-- Input Field -->
       <div class="flex flex-col space-x-2 items-left -mt-7">
        <label
          for="mobileSelect"
          class="ml-2 text-sm font-medium text-gray-700 "
          >Enter number manually
        </label>
         <input
         v-model="selectedMobile"
         type="text"
         placeholder="Or enter phone here"
         class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
         />
        </div>

      <!-- Button -->
      <button
        @click="handleSendWhatsappSaleInvoice()"
        class="px-6 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <div class="flex">
          <span>
            Send to Whatsapp
          </span>
          <span v-if="isWhatsappLoader" class="ml-2 no-rows">
            <i class="fas fa-spinner fa-spin" />
          </span>
        </div>
      </button>

      <button
        @click="handlePrint()"
        class="px-6 py-2 text-white bg-gray-600 rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        <div class="flex">
          <i class="mr-2 fas fa-print" />
          <span>Print</span>
        </div>
      </button>
    </div>
    <div>
      <div class="p-3 bg-gray-100">
        <div
          ref="printArea"
          class="max-w-4xl p-4 mx-auto bg-white rounded-lg shadow-md"
        >
          <div class="flex items-center justify-between pb-4 mb-4 border-b">
            <div>
              <h1 class="text-2xl font-bold text-gray-700">Quote</h1>
              <p class="text-sm text-gray-500">
                {{
                  transformInvoiceNumber(
                    receipt.branchName,
                    receipt.date,
                    receipt.invoiceNumber
                  )
                }}
              </p>
              <p class="text-sm text-gray-500">
                Date: {{ receipt.date | dateFormat }}
              </p>
            </div>
            <div class="text-right">
              <img
                src="../../assets/images/rajput.png"
                width="350"
                height="50"
                alt=""
              />
              <p class="text-sm text-gray-500">Shop No. 13,14, 15</p>
              <p class="text-sm text-gray-500">
                "P" Building, Lokasangam Vihar,
              </p>
              <p class="text-sm text-gray-500">
                Near D.P. Road, Aundh, Pune-07
              </p>
              <p class="text-sm text-gray-500">Phone: 8237478645/8237478647</p>
              <p class="text-sm text-gray-500">GSTIN: 27AEEPR1809Q1ZY</p>
            </div>
          </div>

          <!-- Recipient Details -->
          <div class="flex items-center justify-between pb-4 mb-4 border-b">
            <div>
              <h3 class="mb-2 text-base font-semibold text-gray-700">
                Bill To:
              </h3>
              <p class="text-sm text-gray-500 capitalize">
                {{
                  receipt.userData.firstName + " " + receipt.userData.lastName
                }}
              </p>
              <p class="text-sm text-gray-500">
                Phone: {{ receipt.userData.phone }}
              </p>
            </div>
            <div class="text-right">
              <h2 class="text-base font-semibold text-gray-700">
                Bank Details
              </h2>
              <p class="text-sm text-gray-500">
                Bank Name : Central Bank Of India
              </p>
              <p class="text-sm text-gray-500">
                A/c No. : 3065957826
              </p>
              <p class="text-sm text-gray-500">
                Branch & IFSC Code: Aundh Road & CBIN0283483
              </p>
              <p class="text-sm text-gray-500">Phone: 8237478645/8237478647</p>
              <p class="text-sm text-gray-500">GSTIN: 27AEEPR1809Q1ZY</p>
            </div>
          </div>

          <!-- Items Table -->
          <div class="mb-6">
            <table
              class="w-full text-sm border border-collapse border-gray-200"
            >
              <thead>
                <tr class="bg-gray-100">
                  <th class="px-1 py-2 text-left border border-gray-200">
                    Description
                  </th>
                  <th class="px-1 py-2 text-right border border-gray-200">
                    HSN
                  </th>
                  <th class="px-1 py-2 text-right border border-gray-200">
                    GST
                  </th>
                  <th class="px-1 py-2 text-right border border-gray-200">
                    Qty.
                  </th>
                  <th class="px-1 py-2 text-right border border-gray-200">
                    Rate
                  </th>
                  <th class="px-1 py-2 text-right border border-gray-200">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in receipt.productList" :key="index">
                  <td class="px-1 py-2 border border-gray-200">
                    {{ item.name }}
                  </td>
                  <td class="px-1 py-2 border border-gray-200">
                    {{ item.hsn }}
                  </td>
                  <td class="px-1 py-2 border border-gray-200">
                    {{ item.gstRate }}
                  </td>
                  <td class="px-1 py-2 border border-gray-200">
                    {{ item.quantity }}
                  </td>
                  <td class="px-1 py-2 border border-gray-200">
                    {{ item.rate | currency }}
                  </td>
                  <td class="px-1 py-2 text-right border border-gray-200">
                    {{ item.amount | currency }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer -->
          <div class="flex items-center justify-between pt-4 border-t">
            <div>
              <h3 class="text-lg font-semibold text-gray-700">Notes</h3>
              <p class="text-sm text-gray-500">
                This is computer generated invoice.
              </p>
            </div>
            <div class="text-right">
              <p class="text-sm text-gray-500">
                CGST:
                <span class="font-semibold">{{ receipt.cgst | currency }}</span>
              </p>
              <p class="text-sm text-gray-500">
                SGST:
                <span class="font-semibold">{{ receipt.sgst | currency }}</span>
              </p>
              <p class="text-sm text-gray-500">
                Round Off:
                <span class="font-semibold">{{
                  receipt.roundOff | currency
                }}</span>
              </p>
              <p class="text-sm text-gray-500">
                Grand Total:
                <span class="font-semibold">
                  {{ receipt.grandTotal | currency }}
                </span>
              </p>
              <p class="text-sm text-gray-500">
                Amount In words:
                <span class="font-semibold">
                  {{ receipt.amountInWords }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dateFns from "date-fns";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { printElementAsA4 } from "@/utils/printA4";

export default {
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    dateFormat(value) {
      return dateFns.format(new Date(value), "Do MMM YYYY");
    },
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  data: () => {
    return {
      isWhatsappLoader: false,
      userMobiles: [],
      selectedMobile: null
    };
  },
  computed: {
    ...mapGetters({ receipt: "sale/getReceiptData" })
  },

  mounted() {
    this.getUserMobiles();
  },
  methods: {
    fetchData() {
      this.getUserMobiles();
    },
    resetProperty() {
      this.userMobiles = null; // Reset the property
      this.selectedMobile = null;
    },
    handlePrint() {
      printElementAsA4(this.$refs.printArea, { title: "Sale Invoice" });
    },
    getUserMobiles() {
      const userId = this.receipt && this.receipt.userData && this.receipt.userData.userId;
      if (!userId) {
        this.userMobiles = [];
        return;
      }
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/users/${userId}/mobiles`
        )
        .then(response => {
          this.userMobiles = response.data.mobiles;
        })
        .catch(() => {
          this.userMobiles = [];
        });
    },
    transformInvoiceNumber(branch, date, invoiceNumber) {
      const branchInitials = branch
        .trim()
        .slice(0, 2)
        .toUpperCase();
      const financialYear = this.getFinancialYear(date);
      const paddedNumber = invoiceNumber.toString().padStart(4, "0");
      return branchInitials + financialYear + paddedNumber;
    },
    getFinancialYear(date) {
      const invoiceDate = new Date(date);
      const year = invoiceDate.getFullYear();
      const month = invoiceDate.getMonth() + 1; // Months are 0-indexed in JS

      // If the month is January, February, or March, it's part of the previous financial year
      const startYear = month < 4 ? year - 1 : year;
      const endYear = startYear + 1;

      // Return the financial year in the format 2425
      return `${startYear.toString().slice(-2)}${endYear.toString().slice(-2)}`;
    },
    handleSendWhatsappSaleInvoice() {
      this.isWhatsappLoader = true;
      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/send/sale-invoice/${this.receipt.saleId}`,
          { phone: this.selectedMobile }
        )
        .then(response => {
          this.isWhatsappLoader = false;
          this.userMobiles = [];
          this.selectedMobile = null;
          this.$notify({
            message: "Invoice sent to whtasapp",
            type: "success",
            title: "Success"
          });
        })
        .catch(err => {
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    }
  }
};
</script>
